import React, { useEffect, useReducer } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import './index.scss';

import { ROLES_MANAGER_TYPE } from '../../../utils/enums';
import RoleManager from '../../../services/roleManage';

import SideMenuItem from '../SideMenuItem/SideMenuItem';
import { createSettingsSectionModel } from '../../../services/sectionModelFactory';

const SideMenu = ({ menu, showExit, nestedMenu, clickedNested, clickedSpoiler, hdieText }) => {
    const [, forceUpdate] = useReducer(x => x + 1, 0);

    const rootState = useSelector(state => state);
    const { groupSections, sectionModels, currentModelType } = useSelector(state => state.sectionModel);

    const getModel = path => {
        const model = sectionModels[path];
        return model && model.model ? model : createSettingsSectionModel({ typeModel: path });
    };

    const shouldCallActionFromSideMenu = sectionModels[currentModelType]?.model?.shouldCallActionFromSideMenu;

    useEffect(() => {
        window.addEventListener('resize', forceUpdate);

        return () => {
            window.removeEventListener('resize', forceUpdate);
        };
    }, []);

    return (
        <div className={classNames('sideMenu', { showExit: showExit, isNested: !!nestedMenu || hdieText, autoWidth: hdieText })}>
            <ul className={classNames('mainMenu', { isNested: !!nestedMenu || hdieText })}>
                {menu
                    .filter(
                        menuItem =>
                            RoleManager.instance.isAuthorized(ROLES_MANAGER_TYPE.menu, menuItem.pathname) &&
                            (!menuItem.isShow || menuItem.isShow())
                    )
                    .map(menuItem => (
                        <SideMenuItem
                            checkForUpdate={shouldCallActionFromSideMenu ? shouldCallActionFromSideMenu(rootState) : false}
                            key={menuItem.title}
                            clickedSpoiler={clickedSpoiler}
                            clickedNested={clickedNested}
                            menuItem={menuItem}
                            groupSections={groupSections}
                            rootState={rootState}
                            getModel={getModel}
                        />
                    ))}
            </ul>
            {!!nestedMenu && (
                <div className={'nestedMenu'}>
                    <SideMenu menu={nestedMenu} clickedNested={true} />
                </div>
            )}
            {/*{window.innerWidth <= 768 && <Tooltip />}*/}
        </div>
    );
};

export default withRouter(SideMenu);
